module.exports = __webpack_public_path__ + "img/locator-sentosa.49ac86bb.svg";